import AppointmentInstructions from './AppointmentInstructions.styled';
export default AppointmentInstructions;
